import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {ComboBox, IComboBoxOption, Spinner} from "office-ui-fabric-react";
import React = require("react");
import {DefaultValues, MetadataFields} from "../../../models";
import {DarkModeCalloutStyles} from "../../DarkModeCalloutStyles";
import {TeamsDocumentStatusTabReorderMetadata} from "./TeamsDocumentStatusTabReorderMetadata";

export interface TeamsDocumentStatusTabSearchMetadataState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabSearchMetadataProps {
    metadata: MetadataFields;
    metadataListIndex: number;
    metadataLastListIndex: number;
    shouldReorderMetadata: boolean;
    isDarkMode: boolean;
    searchingProfileAttribute: string;
    reorderCallback: (metadata: MetadataFields, isDirectionUp: boolean) => void;
    runSearchCallback: (value: string, metadata: MetadataFields) => void;
    clearIfEmptyCallback: (metadata: MetadataFields) => void;
    setSearchFilterCallback: (val: IComboBoxOption, field: string, id: string, defaultList: DefaultValues[]) => void;
}

export class TeamsDocumentStatusTabSearchMetadata extends TeamsBaseComponent<
    TeamsDocumentStatusTabSearchMetadataProps,
    TeamsDocumentStatusTabSearchMetadataState
> {
    constructor(props: TeamsDocumentStatusTabSearchMetadataProps) {
        super(props);
    }

    public render() {
        const isDisabled = this.props.metadata.Disabled || this.props.metadata.ManuallyDisabled;

        return (
            <div
                className={
                    this.props.shouldReorderMetadata || this.props.searchingProfileAttribute == this.props.metadata.Id
                        ? "metadataWrapper"
                        : ""
                }
            >
                <div
                    className={
                        this.props.shouldReorderMetadata ||
                        this.props.searchingProfileAttribute == this.props.metadata.Id
                            ? "metadataField"
                            : ""
                    }
                >
                    <ComboBox
                        styles={this.props.isDarkMode ? DarkModeCalloutStyles.getComboBoxStyles() : null}
                        className={this.createClassName(isDisabled)}
                        disabled={isDisabled}
                        label={this.props.metadata.Field}
                        placeholder={"Search..."}
                        options={this.props.metadata.DropDownOptions}
                        required={this.props.metadata.Required}
                        errorMessage={this.props.metadata.ErrorMessage}
                        dropdownWidth={250}
                        allowFreeform={true}
                        openOnKeyboardFocus={true}
                        isButtonAriaHidden={false}
                        onBlur={() => this.props.clearIfEmptyCallback(this.props.metadata)}
                        onPendingValueChanged={(option, pendingIndex, pendingValue) =>
                            this.props.runSearchCallback(pendingValue, this.props.metadata)
                        } // todo: update to 8.75 and use onInputValueChange?
                        onChange={(_, val) =>
                            this.props.setSearchFilterCallback(
                                val,
                                this.props.metadata.Field,
                                this.props.metadata.Id,
                                this.props.metadata.DefaultValuesList
                            )
                        }
                    />
                </div>
                <TeamsDocumentStatusTabReorderMetadata
                    metadata={this.props.metadata}
                    shouldReorderMetadata={this.props.shouldReorderMetadata}
                    reorderCallback={this.props.reorderCallback}
                    metadataListIndex={this.props.metadataListIndex}
                    metadataListLastIndex={this.props.metadataLastListIndex}
                />
                <div
                    hidden={this.props.searchingProfileAttribute != this.props.metadata.Id}
                    className="metadataPositionIcons"
                >
                    <Spinner style={{marginTop: "6px"}} />
                </div>
            </div>
        );
    }

    private createClassName(isDisabled: boolean): string {
        let name = this.props.metadata.DropDownOptions.length == 0 ? "hideCaret " : "";
        name += this.props.isDarkMode && isDisabled ? "darkModeLabelDisabled" : "";
        return name;
    }
}
